import { define } from 'wicked-elements'
import quotes from 'typographic-quotes'
import apostrophes from 'typographic-apostrophes'
import apostrophesForPlurals from 'typographic-apostrophes-for-possessive-plurals'

define('[data-typography]', {
  init() {
    this.element.textContent = apostrophesForPlurals(quotes(apostrophes(this.element.textContent)))
  }
})